import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ConfigService, OAuthProvider } from '../../services/config.service';

@Component({
  selector: 'app-oauth-buttons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './oauth-buttons.component.html',
  styleUrls: ['./oauth-buttons.component.scss']
})
export class OAuthButtonsComponent implements OnInit, OnDestroy {
  oauthProviders: OAuthProvider[] = [];
  isOAuthEnabled: boolean = false;
  isLoading: boolean = true;
  private subscription: Subscription = new Subscription();

  constructor(
    private configService: ConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadOAuthConfig();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private loadOAuthConfig(): void {
    // Suscribirse a cambios en la configuración
    const configSub = this.configService.config$.subscribe(config => {
      if (config) {
        this.isOAuthEnabled = config.oauth?.enabled || false;
        this.oauthProviders = config.oauth?.providers || [];
        this.isLoading = false;
        console.log('📘 OAuth config updated:', { 
          enabled: this.isOAuthEnabled, 
          providers: this.oauthProviders.length 
        });
      }
    });
    this.subscription.add(configSub);

    // El servicio ya carga automáticamente en el constructor
    // Solo necesitamos verificar si ya está disponible
    const currentConfig = this.configService.getCurrentConfig();
    if (currentConfig) {
      this.isOAuthEnabled = currentConfig.oauth?.enabled || false;
      this.oauthProviders = currentConfig.oauth?.providers || [];
      this.isLoading = false;
    }
    // Si no está disponible, el observable config$ se activará cuando se cargue
  }

  /**
   * Iniciar login con proveedor OAuth
   */
  loginWithProvider(provider: OAuthProvider): void {
    if (!provider.enabled) {
      console.warn(`Provider ${provider.name} is disabled`);
      return;
    }

    // Construir URL completa para redirección a OAuth
    const baseUrl = this.configService.getApiUrl();
    const callbackUrl = `${window.location.origin}/auth/${provider.name}/callback`;
    const oauthUrl = `${baseUrl}${provider.login_url}?callback_url=${encodeURIComponent(callbackUrl)}`;
    
    console.log(`Redirecting to ${provider.display_name} OAuth:`, oauthUrl);
    console.log(`Callback URL set to:`, callbackUrl);
    
    // Redirigir a la URL de OAuth
    window.location.href = oauthUrl;
  }

  /**
   * Obtener clases CSS para el botón del proveedor
   */
  getProviderButtonClass(provider: OAuthProvider): string {
    const baseClasses = 'oauth-button';
    const providerClass = `oauth-button--${provider.name}`;
    const enabledClass = provider.enabled ? 'oauth-button--enabled' : 'oauth-button--disabled';
    
    return `${baseClasses} ${providerClass} ${enabledClass}`;
  }

  /**
   * Obtener estilos dinámicos para el botón
   */
  getProviderButtonStyle(provider: OAuthProvider): any {
    if (!provider.enabled) {
      return {
        'background-color': '#cccccc',
        'color': '#666666',
        'cursor': 'not-allowed'
      };
    }

    return {
      'background-color': provider.color,
      'border-color': provider.color
    };
  }

  /**
   * Obtener icono del proveedor (para uso futuro con iconos)
   */
  getProviderIcon(provider: OAuthProvider): string {
    switch (provider.name) {
      case 'facebook':
        return 'fab fa-facebook-f';
      case 'google':
        return 'fab fa-google';
      case 'github':
        return 'fab fa-github';
      case 'microsoft':
        return 'fab fa-microsoft';
      default:
        return 'fas fa-sign-in-alt';
    }
  }
}